// Süper admin › Tahsilat › Ayarlar › Fatura Şirketleri kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.billingIssuers';

export const billingIssuersGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Fatura Şirketleri nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Tahsilatın alınacağı ve faturanın kesileceği şirketleri burada tanımlarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Fatura Şirketleri'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni Şirket'),
    table: t(`${G}.regions.table`, 'Şirket listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Fatura şirketi nedir?'),
      text: t(`${G}.s1.text`, 'Fatura şirketi bir Aquasoft panel şirketine bağlanır. Tahsilat, o şirketin şirket geneli kart ödeme entegrasyonundan alınır (PayTR, Moka veya Param). Fatura ve e-fatura da o şirketin muhasebe hesabıyla kesilir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Merchant bilgisi (Merchant ID, Moka bayi kodu vb.) fatura şirketine kopyalanmaz; her zaman bağlı panel şirketinin aktif ödeme kaydı kullanılır.'),
        t(`${G}.s1.tip2`, 'Şubeye özel ödeme entegrasyonu tahsilata dahil edilmez; panel şirketinde şirket geneli entegrasyon olmalıdır.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Yeni Şirket ekleyin'),
      text: t(`${G}.s2.text`, '"Yeni Şirket" penceresinde "Panel Şirketi"ni seçin (zorunlu; şirket adı veya e-posta ile arayabilirsiniz). VKN, vergi dairesi ve adres fatura kesilirken panel şirketinden otomatik alınır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Fatura Unvanı (opsiyonel): boş bırakılırsa panel şirketinin adı kullanılır.'),
        t(`${G}.s2.tip2`, 'Logo URL (opsiyonel): fatura şirketinin logo adresi.'),
        t(`${G}.s2.tip3`, 'Aktif anahtarı kapalı olan şirket, yeni tahsilat açarken fatura şirketi olarak seçilemez.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Ödeme durumunu kontrol edin'),
      text: t(`${G}.s3.text`, 'Listede unvan, bağlı şirket, e-posta, VKN ve durum görünür. "Ödeme" sütunu panel şirketinin aktif ödeme sağlayıcısını gösterir; "Yok" yazıyorsa o şirkette şirket geneli kart entegrasyonu yoktur ve online tahsilat alınamaz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kopyala simgesi sağlayıcının bildirim (callback) adresini kopyalar. Bu adres sağlayıcı panelinde bildirim URL\'si olarak girilmelidir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Düzenleyin veya silin'),
      text: t(`${G}.s4.text`, 'Satıra tıklayınca ya da kalem simgesiyle şirketi düzenleyin; çöp kutusu simgesi şirketi siler.'),
      tips: [
        t(`${G}.s4.tip1`, 'Fatura şirketi silinen tahsilat kayıtlarında fatura önizlemesi açılmaz ("Kayıtta fatura şirketi seçili değil."). Kullanmayacağınız şirketi silmek yerine Pasif yapmayı tercih edin.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s5.title`, '5. Sayfalar arasında gezinin'),
      text: t(`${G}.s5.text`, 'Liste uzunsa alttaki sayfalamayı kullanın. Sol üstteki mavi kutu kayıtlı fatura şirketi sayısını gösterir.'),
    },
  ],
});
